import { render, staticRenderFns } from "./NavigationFooter.vue?vue&type=template&id=2f75f744&scoped=true"
import script from "./NavigationFooter.vue?vue&type=script&lang=js"
export * from "./NavigationFooter.vue?vue&type=script&lang=js"
import style0 from "./NavigationFooter.vue?vue&type=style&index=0&id=2f75f744&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f75f744",
  null
  
)

export default component.exports